import { render, staticRenderFns } from "./SelectorThumbnails.vue?vue&type=template&id=3951fd14&"
import script from "./SelectorThumbnails.vue?vue&type=script&lang=js&"
export * from "./SelectorThumbnails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/ensign-boligprosjekter/app/public/wp-content/plugins/ensign-boligprosjekter/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3951fd14')) {
      api.createRecord('3951fd14', component.options)
    } else {
      api.reload('3951fd14', component.options)
    }
    module.hot.accept("./SelectorThumbnails.vue?vue&type=template&id=3951fd14&", function () {
      api.rerender('3951fd14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectorThumbnails.vue"
export default component.exports